// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".doc-version[data-v-62bdf2d4]{padding-left:1.5em !important}", "",{"version":3,"sources":["webpack://./src/pages/search/results/table/HitRow.vue"],"names":[],"mappings":"AAEA,8BACC,6BAAA","sourcesContent":["\n\n.doc-version {\n\tpadding-left: 1.5em!important;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
